import { requests, productionRequests } from "@/config/http";

export const capacity_dashboard = report => productionRequests({url: 'manage/capacity_dashboard/', method: 'get', params: {report}});

// 用户
export const login = (data) => requests({url: "users/login/", method:"post", data} );
export const user_list = (params)=>requests({url:'users/',method:'get', params: params});
export const get_user_info = (params)=>requests({url:'users/get_user_info/',method:'get', params: params});
export const get_leader_painter = (params)=>requests({url:'users/get_leader_painter/',method:'get', params: params});


// 关卡任务管理
export const get_approval_option = ()=>requests({url:'manage/paint_task_manage/get_approval_option/',method:'get'});
export const paint_task_manage_list = (params)=>requests({url:'manage/paint_task_manage/',method:'get', params: params});
export const operate_self_review = (id)=>requests({url:`manage/paint_task_manage/${id}/operate_self_review/`,method:'get'});
export const approval_pass = (id, data)=>requests({url:`manage/paint_task_manage/${id}/approval_pass/`, method:'post', data: data});
export const allot_painter = (id, data)=>requests({url:`manage/paint_task_manage/${id}/allot_painter/`, method:'post', data: data});
export const allot_painter_draft = (id, data)=>requests({url:`manage/paint_task_manage/${id}/allot_painter_draft/`, method:'post', data: data});

export const approval_recall = (id, data)=>requests({url:`manage/paint_task_manage/${id}/approval_recall/`, method:'post', data: data});
export const paint_task_manage_create = (data)=>requests({url:`manage/paint_task_manage/`, method:'post', data: data});
export const paint_task_manage_create_s3 = (data)=>requests({url:`manage/paint_task_manage/create_s3/`, method:'post', data: data});
export const get_presigned_url = (data) => requests({url: 'manage/paint_task_manage/get_presigned_url/', method: 'post', data: data});
export const paint_task_manage_update = (id, data)=>requests({url:`manage/paint_task_manage/${id}/`, method:'put', data: data});
export const get_reject_count = (id)=>requests({url:`manage/paint_task_manage/get_reject_count/`, method:'get'});
export const get_sync_task = (id)=>requests({url:`manage/paint_task_manage/get_sync_task/`, method:'get'});


// 批量操作
export const paint_task_manage_batch_create = (data)=>requests({url:`manage/paint_task_manage/batch_create/`, method:'post', data: data});
export const paint_task_manage_batch_create_s3 = (data)=>requests({url:`manage/paint_task_manage/batch_create_s3/`, method:'post', data: data});
export const batch_verify_api = (data)=>requests({url:`manage/paint_task_manage/batch_verify/`, method:'post', data: data});
export const batch_reject_api = (data)=>requests({url:`manage/paint_task_manage/batch_reject/`, method:'post', data: data});
export const batch_recall_api = (data)=>requests({url:`manage/paint_task_manage/batch_recall/`, method:'post', data: data});
export const batch_delete_api = (data)=>requests({url:`manage/paint_task_manage/batch_delete/`, method:'post', data: data});
export const batch_pass_api = (data)=>requests({url:`manage/paint_task_manage/batch_pass/`, method:'post', data: data});
export const batch_pass_draft_api = (data)=>requests({url:`manage/paint_task_manage/batch_pass_draft/`, method:'post', data: data});
export const batch_appoint_api = (data)=>requests({url:`manage/paint_task_manage/batch_appoint/`, method:'post', data: data});
export const batch_appoint_draft_api = (data)=>requests({url:`manage/paint_task_manage/batch_appoint_draft/`, method:'post', data: data});
export const batch_update_fields_api = (data)=>requests({url:`manage/paint_task_manage/batch_update_fields/`, method:'post', data: data});


// 配置
export const cate_list = (params)=>requests({url:'manage/category/',method:'get', params: params});
export const cate_update = (id, data)=>requests({url:`manage/category/${id}/`, method:'put', data: data});
export const cate_create = (data)=>requests({url:`manage/category/`, method:'post', data: data});
export const update_status_api = (id, data)=>requests({url:`manage/category/${id}/update_status/`, method:'post', data: data});

// 生产配置：同类接口保持真实 HTTP 失败，旧任务请求不受影响。
export const production_list = (resource, params) => productionRequests({url: `manage/${resource}/`, method: 'get', params});
export const production_create = (resource, data) => productionRequests({url: `manage/${resource}/`, method: 'post', data});
export const production_update = (resource, id, data) => productionRequests({url: `manage/${resource}/${id}/`, method: 'patch', data});
export const production_delete = (resource, id) => productionRequests({url: `manage/${resource}/${id}/`, method: 'delete'});
export const production_category_status = (id, data) => productionRequests({url: `manage/category/${id}/update_status/`, method: 'post', data});

/** 完整读取配置或主管目录；任何一页失败都拒绝，不返回残缺目录。 */
export async function production_options(resource, params = {}) {
  const rows = [];
  let offset = 0;
  while (true) {
    const response = await productionRequests({url: resource === 'users' ? 'users/' : `manage/${resource}/`, method: 'get', params: {...params, limit: 100, offset}});
    const page = resource === 'users' && response && response.code === 200000 ? response.data : response;
    if (!page || !Array.isArray(page.results) || typeof page.count !== 'number') throw new Error('目录响应格式错误');
    rows.push(...page.results);
    if (!page.next) return rows;
    if (!page.results.length) throw new Error('目录分页未完成，请重试');
    offset += page.results.length;
  }
}
